/**
 * To safely access window instance in SSR.
 */
export const getWindow = (): typeof globalThis =>
  typeof window !== 'undefined'
    ? window
    : {
        ...globalThis,
        innerWidth: 0,
        innerHeight: 0,
        matchMedia: (() => ({
          matches: false,
        })) as unknown as Window['matchMedia'],
      };
